import * as React from "react";

export interface FillHintProps {
    visible: boolean;
    children: React.ReactNode;
}

export function FillHint(props: FillHintProps): React.ReactElement {
    return <>{props.visible && props.children}</>;
}
